import { render, staticRenderFns } from "./NewSalesOrderDocumentInvoicePage.vue?vue&type=template&id=55a0bed0&scoped=true"
import script from "./NewSalesOrderDocumentInvoicePage.vue?vue&type=script&lang=js"
export * from "./NewSalesOrderDocumentInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a0bed0",
  null
  
)

export default component.exports